import axios from "axios";

const api = axios.create({
  // baseURL: "https://dev-api.talchi.ai/api",
  baseURL: "https://itconnectus-api.talchi.ai/api",
});

api.header_required = false; // Flag to indicate if authentication headers are required for API requests.
api.app_name = "Talchi.ai";
api.interview_link = "https://itconnectus.talchi.ai/ai-test"
api.career_link = "https://itconnectus.talchi.ai/careers/"
api.backend_link = "https://itconnectus.talchi.ai/api/"
api.ui_link =  "https://itconnectus.talchi.ai/login";
// api.interview_link = "https://dev.talchi.ai/ai-test" 
// api.career_link = "https://dev.talchi.ai/careers/"   
// api.backend_link = "https://dev-api.talchi.ai/api/"  
// api.ui_link =  "https://dev.talchi.ai/login";
api.jobsPerPage = 25;

export default api;